import { ForwardedRef, forwardRef, PropsWithChildren } from 'react';

import { ListMode } from '../../utils/types/stateful-list.types';
import { ItemListWrapper } from '../item-list-wrapper/item-list-wrapper';
import ListSearch from '../search/list-search';
import ListSelectAll from '../select-all/list-select-all';

import { MultiSelectContext } from './multi-select.context';
import { MultiSelectInputProps } from './multi-select.types';
import { useMultiState } from './use-multi-state';

export const ListMultiSelectProvider = forwardRef(
  (
    props: PropsWithChildren<MultiSelectInputProps>,
    ref?: ForwardedRef<HTMLDivElement>
  ) => {
    const value = useMultiState(props);
    const { useSearch, useSelectAll } = value;

    return (
      <MultiSelectContext.Provider value={value}>
        <ItemListWrapper
          {...props}
          ref={ref}
          activeDescendantId={value.activeDescendantId}
          containerRef={value.containerRef}
          onKeyDown={value.onKeyDown}
          renderItems={value.renderItems}
          mode={ListMode.Multi}
        >
          {useSearch && (
            <ListSearch
              search={value.search}
              setSearch={value.setSearch}
              focusId={`focusable-item-search-input-${value.renderItems.id}`}
              activeDescendantId={value.activeDescendantId}
            />
          )}
          {useSelectAll && (
            <ListSelectAll
              className={!useSearch ? 'no-border-radius' : ''}
              focusId={`focusable-item-select-all-${value.renderItems.id}`}
            />
          )}
        </ItemListWrapper>
      </MultiSelectContext.Provider>
    );
  }
);

export default ListMultiSelectProvider;
